export const COMPANIES_FETCH_REQUESTED_DE = 'COMPANIES_FETCH_REQUESTED_DE';
export const fetchCompaniesDELending = (searchTerms) => ({
    type: COMPANIES_FETCH_REQUESTED_DE,
    searchTerms
});

export const RESET_FETCHED_COMPANIES = 'RESET_FETCHED_COMPANIES';
export const resetFetchedCompanies = () => ({ type: RESET_FETCHED_COMPANIES });

export const LEGAL_FORM_FETCH_REQUESTED_DE = 'LEGAL_FORM_FETCH_REQUESTED_DE';
export const fetchLegalForm = (crefoId) => ({
    type: LEGAL_FORM_FETCH_REQUESTED_DE,
    crefoId
});
